import React from "react";
import "./imagePolygon.css";
import ImagePolygonItem from "./ImagePolygonItem";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
};

const ImagePolygon = () => {
  const isMobile = useIsMobile();
  const images = [
    {
      src: "./assets/imgs/poligonosHome/1.jpg",
      clipPath: isMobile
        ? "polygon(87% 60%, 18% 100%, 0 62%, 8% 30%, 46% 0, 100% 0)"
        :
        // "polygon(58% 16%, 100% 82%, 62% 100%, 30% 92%, 0 54%, 0 0)",
        "polygon(48% 16%, 100% 84%, 60% 100%, 29% 92%, 0 54%, 0 0)",
      style: {
        height: isMobile ? "450px" : "410px",
        filter: "grayscale(100%)",
        position: "relative",
        top: isMobile ? "20px" : "0px",
      },
    },
    {
      src: "./assets/imgs/poligonosHome/2.jpg",
      clipPath: isMobile
        ? "polygon(84% 59%, 18% 100%, 0 70%, 8% 45%, 81% 0, 100% 22%)"
        :
        // "polygon(65% 15%, 100% 82%, 70% 100%, 45% 100%, 0 10%, 22% 0)",
        "polygon(22% 0, 59% 16%, 100% 81%, 70% 100%, 45% 92%, 0 20%)",
      style: {
        height: isMobile ? "450px" : "410px",
        filter: "grayscale(100%)",
        position: "relative",
        bottom: isMobile ? "100px" : "0px",
      },
    },
    {
      src: "./assets/imgs/poligonosHome/3.jpg",
      clipPath: isMobile
        ? "polygon(100% 28%, 84% 76%, 49% 100%, 4% 100%, 0 91%, 8% 56%, 81% 0%)"
        : "polygon(28% 0, 76% 16%, 100% 51%, 100% 96%, 91% 100%, 56% 92%, 0 10%)",
      style: {
        height: isMobile ? "400px" : "410px",
        filter: "grayscale(100%)",
        position: "relative",
        bottom: isMobile ? "220px" : "0px",
      },
    },
  ];

  return (
    <div className="image-container container-fluid">
      <div className="image-wrapper row">
        {images.map((img, idx) => (
          <ImagePolygonItem
            key={idx}
            index={idx}
            src={img.src}
            clipPath={img.clipPath}
            style={img.style}
          />
        ))}
      </div>
    </div>
  );
};

export default ImagePolygon;
